/* eslint-disable jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for */
import React from 'react';
import { connect } from 'react-redux';
import { Button, Col } from 'reactstrap';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import {
  API,
  BASE_URL,
  TIPO_PLAN_CUOTAS_ID,
  TIPO_PLAN_LIBRO_VENTAS_ID,
  TIPO_PLAN_PLAN_PAGOS_ID
} from '../../../CONST';
import { fileDownload, pluralize } from '../../../helpers/helpers';
import FormSection from '../../layout/FormSection';
import CreditPolicyDetailFiliales from '../../CreditPolicyDetailFiliales';
import CreditPolicyDetailBeneficiarios from '../../CreditPolicyDetailBeneficiarios';

const CorredorCreditoPolicyDetailBasicInfo = ({policy, loginIdToken}) => {
  if (policy === null)
    return null;

  const { base, base: { poliza_maestra: polizaMaestra } } = policy;
  const balance = policy.endosos.find(endoso => endoso.id === policy.balance);
  const note = '*Los datos mostrados corresponden a valores de la póliza vigente al día de hoy.';

  return (
    <Col md={{ offset: 2, size: 8 }}>
      <FormSection
        title={`Información básica - ${base.nemotecnico} (Vigencia: #${balance.numero_vigencia} Endoso: #${balance.secuencia_endoso})`}
        style={{ marginTop: '70px' }}
      >
        <p className="form-section-label">{note}</p>
        <div className="p-2 rounded">
          <div className="row mb-2">
            <div className="col-md-6 d-flex flex-column">
              <div className="d-flex p-2 mb-2 rounded flex-grow-1" style={{ backgroundColor: 'rgba(33, 87, 151, 0.05)' }}>
                <label htmlFor="moneda" className="mb-1" style={{ width: '40%' }}>Moneda</label>
                <p id="moneda" className="small-form-value mt-0 mb-1" style={{ width: '60%' }}>
                  {base.moneda_asegurada.descripcion}
                </p>
              </div>
            </div>
            <div className="col-md-6 d-flex flex-column">
              <div className="d-flex p-2 mb-2 rounded flex-grow-1" style={{ backgroundColor: 'rgba(33, 87, 151, 0.05)' }}>
                <label htmlFor="ramo-fecu" className="mb-1" style={{ width: '40%' }}>Ramo FECU</label>
                <p id="ramo-fecu" className="small-form-value mt-0 mb-1" style={{ width: '60%'}}>
                  {polizaMaestra.ramo_asegurado.descripcion}
                </p>
              </div>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-6 d-flex flex-column my-1">
              <div className="d-flex p-2 mb-0 rounded flex-grow-1">
                <label htmlFor="condicionado-general" className="mb-1" style={{ width: '40%' }}>Condicionado general</label>
                <p id="condicionado-general" className="small-form-value my-0" style={{ width: '60%' }}>
                  <a
                    href={polizaMaestra.url}
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{color: '#215797'}}
                  >
                    <u>{polizaMaestra.nemotecnico}</u>
                  </a>
                  <Button
                    title="Descargar"
                    className="form-values download"
                    onClick={() => fileDownload(
                      `${BASE_URL}${API.fullCreditos}/${policy.id}/download-maestra/`,
                      loginIdToken,
                      )}
                    style={{marginLeft: '10px'}}
                  >
                    <FontAwesomeIcon icon={faDownload} />
                  </Button>
                </p>
              </div>
              <hr className="w-100 mt-auto"/>
            </div>
            <div className="col-md-6 d-flex flex-column my-1">
              <div className="d-flex p-2 mb-0 rounded flex-grow-1">
                <label htmlFor="producto" className="mb-1" style={{ width: '40%' }}>Producto</label>
                <p id="producto" className="small-form-value my-0" style={{ width: '60%'}}>
                  {base.producto.descripcion}
                </p>
              </div>
              <hr className="w-100 mt-auto"/>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-6 d-flex flex-column">
              <div className="d-flex p-2 mb-2 rounded flex-grow-1" style={{ backgroundColor: 'rgba(33, 87, 151, 0.05)' }}>
                <label htmlFor="tipo-cobertura" className="mb-1" style={{ width: '40%' }}>Tipo de cobertura</label>
                <p id="tipo-cobertura" className="small-form-value mt-0 mb-1" style={{ width: '60%'}}>
                  {base.tipo_cobertura.descripcion}
                </p>
              </div>
            </div>
            <div className="col-md-6 d-flex flex-column">
              <div className="d-flex p-2 mb-2 rounded flex-grow-1" style={{ backgroundColor: 'rgba(33, 87, 151, 0.05)' }}>
                <label htmlFor="tipologia-ejecucion" className="mb-1" style={{ width: '40%' }}>Ejecución</label>
                <p id="tipologia-ejecucion" className="small-form-value mt-0 mb-1" style={{ width: '60%'}}>
                  {base.tipologia_ejecucion.descripcion}
                </p>
              </div>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-6 d-flex flex-column my-1">
              <div className="d-flex p-2 mb-0 rounded flex-grow-1">
                <label htmlFor="forma-pago" className="mb-1" style={{ width: '40%' }}>Forma de pago</label>
                <p id="forma-pago" className="small-form-value my-0" style={{ width: '60%' }}>
                  {balance.plan_pago.tipo === TIPO_PLAN_LIBRO_VENTAS_ID && 'Libro de Ventas'}
                  {balance.plan_pago.tipo === TIPO_PLAN_CUOTAS_ID &&
                    `En ${pluralize('cuota', balance.plan_pago.cuotas)}`}
                  {balance.plan_pago.tipo === TIPO_PLAN_PLAN_PAGOS_ID && 'Plan de pago'}
                </p>
              </div>
              <hr className="w-100 mt-auto"/>
            </div>
            <div className="col-md-6 d-flex flex-column my-1">
              <div className="d-flex p-2 mb-0 rounded flex-grow-1">
                <label htmlFor="tipo-intermediario" className="mb-1" style={{ width: '40%' }}>Tipo de intermediario</label>
                <p id="tipo-intermediario" className="small-form-value my-0" style={{ width: '60%'}}>
                  {base.tipo_intermediario.descripcion}
                </p>
              </div>
              <hr className="w-100 mt-auto"/>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-6 d-flex flex-column">
              <div className="d-flex p-2 mb-2 rounded flex-grow-1" style={{ backgroundColor: 'rgba(33, 87, 151, 0.05)' }}>
                <label htmlFor="intermediario" className="mb-1" style={{ width: '40%' }}>Intermediario</label>
                <p id="intermediario" className="small-form-value mt-0 mb-1" style={{ width: '60%'}}>
                  {balance.intermediario ? `${balance.intermediario.rut} - ${balance.intermediario.nombre}` : ''}
                </p>
              </div>
            </div>
            <div className="col-md-6 d-flex flex-column">
              <div className="d-flex p-2 mb-2 rounded flex-grow-1" style={{ backgroundColor: 'rgba(33, 87, 151, 0.05)' }}>
                <label htmlFor="asegurado" className="mb-1" style={{ width: '40%' }}>Asegurado</label>
                <p id="asegurado" className="small-form-value mt-0 mb-1" style={{ width: '60%'}}>
                  {base.asegurado ? `${base.asegurado.rut} - ${base.asegurado.nombre}`: ''}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-md-6">
            <label htmlFor="filiales">Filiales</label>
            <CreditPolicyDetailFiliales
              filiales={balance.clienteendoso_set.filter(cli => cli.is_filial)}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="filiales">Beneficiarios</label>
            <CreditPolicyDetailBeneficiarios
              beneficiarios={balance.clienteendoso_set.filter(cli => cli.is_beneficiario)}
            />
          </div>
        </div>
      </FormSection>
    </Col>
  )
};

CorredorCreditoPolicyDetailBasicInfo.propTypes = {
  policy: PropTypes.shape({
    id: PropTypes.number.isRequired,
    balance: PropTypes.number,
    base: PropTypes.object,
    endosos: PropTypes.array,
  }),
  loginIdToken: PropTypes.string.isRequired,
};

CorredorCreditoPolicyDetailBasicInfo.defaultProps = {
  policy: null,
};

const mapStateToProps = state => ({
  loginIdToken: state.login.id_token,
});

export default connect(mapStateToProps)(CorredorCreditoPolicyDetailBasicInfo);
